import { action, computed, makeObservable, observable } from 'mobx'

export class ManagedDialogState {
  @observable dialogActive: boolean = false
  @observable dialogDebounced: boolean = false
  debounceTimeout: NodeJS.Timeout | undefined

  /** to be called in cubit disposer, to close all dialogs which rely on cubit state */
  clearSelf: undefined | VoidFunction = undefined

  constructor() {
    makeObservable(this)
  }

  //make a getter for canPop
  @computed
  get canShow() {
    return !this.dialogActive && !this.dialogDebounced
  }

  _clearDebounce = () => {
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = undefined
  }

  @action
  mounted(clearSelf: () => void) {
    this.dialogActive = true
    this.clearSelf = clearSelf
    this._clearDebounce()
  }

  @action
  unmounted() {
    this._clearDebounce()
    this.dialogDebounced = true
    this.dialogActive = false
    this.clearSelf = undefined
    this.debounceTimeout = setTimeout(() => {
      this.undebounce()
    }, 30 * 1000)
  }

  @action
  undebounce() {
    this.dialogDebounced = false
  }
}
